<template>
  <ConfigProvider :locale="getAntdLocale" :direction="toggleDirection ? 'rtl' : getDirection">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import { onMounted, ref, computed, watch } from 'vue';
  import { ConfigProvider } from 'ant-design-vue';
  import { AppProvider } from '/@/components/Application';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';
  import { useLinkStore } from '/@/store/modules/link';
  import { useAppUserStore } from '/@/hooks/app/useAppUserStore';
  import { useAppDayjs } from '/@/hooks/app/useAppDayjs';
  import { useAppVersion } from '/@/hooks/app/useAppVersion';
  import { useAppStorage } from '/@/hooks/app/useAppStorage';
  import { useAppScripts } from '/@/hooks/app/useAppScripts';
  import { handleInit } from '/@/utils/business/buriedPoint';

  useTitle();
  const { getAntdLocale, getDirection } = useLocale();
  const linkStore = useLinkStore();

  const toggleDirection = ref(false);

  useAppDayjs();
  useAppVersion();
  useAppStorage();
  const { userInfo, user, token, globalConfig } = useAppUserStore();
  useAppScripts(globalConfig, user);

  /** Mixpanel */
  const mixpanelEnabled = computed(() => {
    return globalConfig.value?.uba?.mixpanel?.enabled;
  });
  const mixpanelToken = computed(() => {
    return globalConfig.value?.uba?.mixpanel?.token;
  });
  const userId = computed(() => {
    return user.value?.id;
  });
  watch(
    [token, mixpanelEnabled, userId],
    () => {
      if (mixpanelEnabled.value && mixpanelToken.value && userId.value) {
        handleInit({
          mixpanelToken: mixpanelToken.value,
          mixpanelEnabled: mixpanelEnabled.value,
          userId: userId.value,
          userInfo: userInfo.value,
        });
      }
    },
    { immediate: true },
  );

  onMounted(async () => {
    if (import.meta.env.PROD) {
      console.log = () => {};
    }

    setTimeout(() => {
      linkStore.getExternalLink();
    }, 1000);
  });
</script>
